import * as React from 'react'

import classNames from 'classnames/bind'
import isEmpty from 'lodash/isEmpty'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'
import { normalizeText } from 'modules/core/lib/stringUtils'

import BrowserImage, { SITES } from './BrowserImage'
import type { SiteType, SizeType } from './BrowserImage'
import styles from './index.module.scss'

type Domain = React.ReactNode | string
interface Props {
  subdomain?: string | null | undefined
  domain: Domain
  size?: SizeType
  site?: SiteType
  faviconImage?: any
}

const cx = classNames.bind(styles)

export const normalizeSubdomain = (s: string): string =>
  normalizeText(s.replace(/[%$#@/=?+]/g, ''))
    .replace(/[\s_]+/g, '-')
    .replace(/[-]+/g, '-')

const BrowserBarPreview = ({ size, subdomain, domain, faviconImage, site }: Props) => {
  if (site === SITES.linkedin) {
    return (
      <div className={styles.browserPreview}>
        <BrowserImage faviconImage={faviconImage} site={site} size={size} />
        <div className={cx('textWrapper', size)}>
          <div className={styles.domain}>{domain}</div>
        </div>
      </div>
    )
  }

  const normalizedSubdomain = subdomain ? normalizeSubdomain(subdomain) : ''

  const value = isEmpty(normalizedSubdomain)
    ? i18n.t('settings.edit_company.company_subdomain_example')
    : normalizedSubdomain

  return (
    <div className={styles.browserPreview}>
      <BrowserImage faviconImage={faviconImage} size={size} />
      <div className={cx('textWrapper', size)}>
        <div className={site === SITES.complaints ? styles.subdomain : styles.domain}>https://</div>
        <div className={styles.subdomain}>{value}</div>
        <div className={site === SITES.complaints ? styles.subdomain : styles.domain}>
          .{domain}
        </div>
      </div>
    </div>
  )
}

export default observer(BrowserBarPreview)
